module.exports = __webpack_public_path__ + "static/media/backyard-banner.970e386a.png";